module.exports = __webpack_public_path__ + "img/aerial_view.6b1af894.svg";